import { useMemo } from "react";
import {
  APP_NAV_TOUR_STEPS,
  type AppNavTourStep,
} from "../data/appNavTourSteps";
import type { AppNavItemKey } from "../components/layout/commandCentreTypes";
import { useAppNavItems } from "./useAppNavItems";

/**
 * Tour steps aligned with tier-gated sidebar items (same source as FAQ gating via nav).
 */
export function useAppNavTourSteps(): AppNavTourStep[] {
  const { items } = useAppNavItems();

  return useMemo(() => {
    const allowedTargets = new Set<AppNavItemKey>(
      items
        .map((item) => item.tourTargetId)
        .filter((id): id is AppNavItemKey => id !== undefined)
    );

    return APP_NAV_TOUR_STEPS.filter((step) => {
      if (!step.targetId) return true;
      return allowedTargets.has(step.targetId);
    });
  }, [items]);
}
